import { AxiosError } from 'axios';

export interface InterceptedError<
  T = {
    errors: string[];
    invalid_params: {
      type: string;
      input?: string;
      loc: string[];
      msg: string;
    }[];
    [key: string]: any;
  },
> extends AxiosError<T> {}

export const getErrorStatus = (error: unknown) => {
  const interceptedError = error as InterceptedError | undefined;
  return interceptedError?.status ?? interceptedError?.response?.status;
};

//TODO extend